import { faPlay } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import React from 'react';
import PlayBtn from '../../../main/components/PlayBtn';
const NewsCard = ({ news }) => {
    return (
        <div className="col-md-12">
            <div className="news-card-container ">
                <div className="card border-0 text-white ">
                    <img src={news?.featured_logo?.url} className="img-fluid d-flex justify-content-start" alt="..."></img>
                    <div className="d-flex position-absolute top-0 end-0 mt-2  justify-content-end pe-3 pinter-cursor  secondary-text">

                        <PlayBtn link={news?.video_link && news?.video_link} />

                    </div>
                    <a className="new-card " href={news?.external_link[0]?.text ? news?.external_link[0]?.text : null}>
                        <h5>{news?.title1[0]?.text}</h5>
                        <p className="section-body  mb-0 pb-0">{

                            news?.description1[0]?.text?.length > 70 ? ` ${news?.description1[0]?.text?.slice(0, 70)} .....` : news?.description1[0]?.text}</p>
                    </a>

                </div>
            </div>
        </div>
    );
};

export default NewsCard;